var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.98043 0.5H6.27455L7.92161 4.61765L5.86279 5.85294C6.74475 7.64126 8.19211 9.08862 9.98043 9.97059L11.2157 7.91176L15.3334 9.55882V12.8529C15.3334 13.2898 15.1598 13.7087 14.851 14.0176C14.5421 14.3265 14.1231 14.5 13.6863 14.5C10.4739 14.3048 7.44409 12.9406 5.16841 10.665C2.89273 8.38929 1.52859 5.35943 1.33337 2.14706C1.33337 1.71023 1.5069 1.2913 1.81579 0.982412C2.12467 0.673529 2.54361 0.5 2.98043 0.5Z",
    stroke: "var(--brand-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRed);
export default __webpack_public_path__ + "static/media/phone-red.5245ec6793bc9a42846f46076509544c.svg";
export { ForwardRef as ReactComponent };